import { useEffect, useState } from 'react';

import {
  FiltrYearTypeEnum,
  InvoiceTypeEnum,
  CurrencyIsoTypeEnum,
  PurchaseInvoiceStatusEnum,
} from '../../../../common/pokCore/validation/enums';

export const useFilterYearState = (withYearType?: boolean) => {
  const [showNewAlert, setShowNewAlert] = useState(false);
  const [year, setYear] = useState<number>();
  const [rangeMonth, setRangeMonth] = useState<
    [Date | null, Date | null] | null
  >();
  const [yearsOptions, setYearsOptions] = useState<
    { value: number; label: string }[]
  >([]);
  const [companyId, setCompanyId] = useState<string>();
  const [type, setType] = useState<InvoiceTypeEnum>();
  const [budget, setBudget] = useState<string>();
  const [currency, setCurrency] = useState<CurrencyIsoTypeEnum>();
  const [clientId, setClientId] = useState<string>();
  const [status, setStatus] = useState<PurchaseInvoiceStatusEnum>();
  const [yearType, setYearType] = useState<FiltrYearTypeEnum | undefined>(
    withYearType ? FiltrYearTypeEnum.DateOfIssue : undefined,
  );
  const [teamId, setTeamId] = useState<string | undefined>();
  const [saleDate, setSaleDate] = useState<[Date | null, Date | null] | null>();
  const [invoiceDate, setInvoiceDate] = useState<
    [Date | null, Date | null] | null
  >();
  const [invoiced, setInvoiced] = useState(true);
  const [salesInvoices, setSalesInvoices] = useState(true);
  const [salesInvoicesCopies, setSalesInvoicesCopies] = useState(false);
  const [purchaseInvoices, setPurchaseInvoices] = useState(true);
  const [project, setProject] = useState<string | undefined>();
  const [attachmentsTypesIds, setAttachmentsTypesIds] = useState<string[]>();
  const [contracts, setContracts] = useState(true);
  const [projectAttachments, setProjectAttachments] = useState(true);

  const setDate = (date: Date | undefined) => {
    if (date) {
      date.setMinutes(-date.getTimezoneOffset());
      return date;
    }
    return undefined;
  };

  const [month, setMonth] = useState<Date | undefined>(
    setDate(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 20)),
  );

  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const options = [];
    for (let year: number = 2024; year <= currentYear + 1; year++) {
      options.push({ value: year, label: String(year) });
    }
    setYearsOptions(options);
    setYear(currentYear);
    setRangeMonth([new Date(currentYear, 0, 1), new Date(currentYear, 11, 31)]);
    setCompanyId(undefined);
    setBudget(undefined);
    setCurrency(undefined);
    setType(undefined);
    setClientId(undefined);
    setSaleDate(undefined);
    setInvoiceDate(undefined);
    setStatus(undefined);
    setTeamId(undefined);
    setMonth(
      setDate(
        new Date(new Date().getFullYear(), new Date().getMonth() - 1, 20),
      ),
    );
    setInvoiced(true);
    setSalesInvoices(true);
    setSalesInvoicesCopies(false);
    setPurchaseInvoices(true);
    setContracts(true);
    setProjectAttachments(true);
    setProject(undefined);
    setAttachmentsTypesIds(undefined);
  }, []);

  const clearFilters = () => {
    const currentYear = new Date().getFullYear();
    setYear(currentYear);
    setCompanyId('');
    setBudget('');
    setClientId('');
    setCurrency(undefined);
    setType(undefined);
    setShowNewAlert(false);
    setSaleDate(undefined);
    setInvoiceDate(undefined);
    setStatus(undefined);
    setTeamId(undefined);
    setRangeMonth([new Date(currentYear, 0, 1), new Date(currentYear, 11, 31)]);
    setMonth(
      setDate(
        new Date(new Date().getFullYear(), new Date().getMonth() - 1, 20),
      ),
    );
    setInvoiced(true);
    setSalesInvoices(true);
    setSalesInvoicesCopies(false);
    setPurchaseInvoices(true);
    setContracts(true);
    setProjectAttachments(true);
    setProject(undefined);
    setAttachmentsTypesIds(undefined);
  };

  return {
    // State values
    showNewAlert,
    setShowNewAlert,
    year,
    setYear,
    rangeMonth,
    setRangeMonth,
    yearsOptions,
    companyId,
    setCompanyId,
    type,
    setType,
    budget,
    setBudget,
    currency,
    setCurrency,
    clientId,
    setClientId,
    status,
    setStatus,
    yearType,
    setYearType,
    teamId,
    setTeamId,
    saleDate,
    setSaleDate,
    invoiceDate,
    setInvoiceDate,
    invoiced,
    setInvoiced,
    salesInvoices,
    setSalesInvoices,
    salesInvoicesCopies,
    setSalesInvoicesCopies,
    purchaseInvoices,
    setPurchaseInvoices,
    project,
    setProject,
    attachmentsTypesIds,
    setAttachmentsTypesIds,
    contracts,
    setContracts,
    projectAttachments,
    setProjectAttachments,
    month,
    setMonth,
    setDate,
    clearFilters,
  };
};
